<template>
  <div class="ml-auto px-4 mr-1 d-flex align-center">
    <v-switch
        hide-details
        dense
        v-model="insuranceAuto"
        @click="update"
        class="pa-0 ma-0 v-input--reverse"
        label="Assistance rapatriement automatique"
        height="46px"
    />
  </div>

</template>

<script>

import {get, post} from "@/utils/api";

export default {
  name: "AutoFlightInsurance",
  components: {},
  data() {
    return {
      insuranceAuto: true,
      booking: null
    }
  },
  props: {
    bookingId: {type: Number, require: true},
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      get(`/api/booking/${this.bookingId}`).json((res) => {
        this.insuranceAuto = res.data.flightInsuranceAuto
      })
    },
    update() {
      post(`/api/booking/${this.bookingId}/flight-insurance-auto`, {isAuto: this.insuranceAuto})
    },
  }
}
</script>
<style>
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;

  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }

  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}
</style>